import { Controller } from "remult";

@Controller("team-manager-methods")
export class TeamManagerMethods {}
